import { haptic } from "../platform/telegram";
import "./froshbot-pill.css";

/**
 * The FroshBot entry pill — e2, bottom-right, present on every top-level screen.
 *
 * It is anchored to `viewportStableHeight` rather than the bottom edge, and
 * offsets by the MainButton height (44) plus 12 whenever MainButton is showing.
 * Anchoring to the edge would put it under the keyboard the moment any field
 * gains focus, which is precisely when someone reaches for it.
 */
export function FroshBotPill({ onOpen, raised = false }: { onOpen: () => void; raised?: boolean }) {
  return (
    <button
      type="button"
      className={`froshbot-pill${raised ? " froshbot-pill--raised" : ""}`}
      onClick={() => {
        haptic.press();
        onOpen();
      }}
    >
      <span className="froshbot-pill__mark">
        <img src="/brand/f-white-bold.png" alt="" />
      </span>
      Froshbot
    </button>
  );
}
